import { CollapsibleSection } from './collapsible-section';

interface SectionLoadingStateProps {
  title: string;
}

export function SectionLoadingState({ title }: SectionLoadingStateProps) {
  return (
    <CollapsibleSection title={title} defaultExpanded>
      <div className='h-16 bg-[var(--color-bg-tertiary)]/10 rounded-xl animate-pulse' />
    </CollapsibleSection>
  );
}

interface SectionErrorStateProps {
  title: string;
  message: string;
  onRetry: () => void;
}

export function SectionErrorState({
  title,
  message,
  onRetry,
}: SectionErrorStateProps) {
  return (
    <CollapsibleSection title={title} defaultExpanded>
      <div className='p-3 bg-utility-error-50 border border-utility-error-200 rounded-lg'>
        <p className='text-xs md:text-sm font-medium text-utility-error-800'>
          {message}
        </p>
        <button
          type='button'
          onClick={onRetry}
          className='mt-1 text-xs md:text-sm text-utility-error-800 underline hover:no-underline'
        >
          Retry
        </button>
      </div>
    </CollapsibleSection>
  );
}
